import websocketService from '../../websocketService';

export default {
  methods: {
    sendMessage(command, data) {
      websocketService.sendMessage({ action: command, data });
    },
  },
};
